import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { TicketModel } from "./ticket.model";
import { TicketService } from "./ticket.service";
import { QRCodeModel } from '../../qr/qrcode.model';
import * as FileSaver from 'file-saver';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { TicketDialogTotalComponent } from './ticket-dialog-total.component';
import { HttpClient } from "@angular/common/http";
import { ShowQRModel } from "../invoice/showqr.model";
import { InvoiceDialogPaidedComponent } from '../invoice/invoice-dialog-paided.component';
import { CoreComponent } from '../../../core/header/core.component';
import { InvoiceTicketsConst } from '../const';
import { TicketDialogRectificationComponent } from './ticket-dialog-rectification.component';
import { DummyComponent } from '../../../shared/dummy.component';
import { ActualSelected, Utils } from '../../../shared/utils';
import { AccountingMovementsService } from '../../accounting/movements/accounting-movements.service';
import { TableService } from '../../../shared/components/table/table.service';
import { consts } from '../../../consts';
import { InvoiceDialogVerifactuComponent } from '../invoice/invoice-dialog-verifactu.component';
import { TicketDialogProjectComponent } from './ticket-dialog-project.component';
import { EmailDialogComponent } from './email-dialog.component';
import { ActivityService } from '../../user/activity/activity.service';

@Component({
    selector: 'convfact-ticket-list',
    templateUrl: './ticket-list.component.html',
    styleUrls: ['./ticket.component.css'],
    standalone: false
})
export class TicketListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  constructor(
    private router: Router,
    private ticketService: TicketService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private core: CoreComponent,
    private dummy: DummyComponent,
    private accountingMovementsService: AccountingMovementsService,
    private tableService: TableService,
    private activityService : ActivityService
  ) { }

  dataSource: TicketModel[] = [];
  preSource: TicketModel[] = [];
  showQRList: ShowQRModel[] = [];

  ticket: TicketModel;
  showQR: boolean = false;
  empty: boolean = false;
  ready: boolean = false;
  spinner: boolean = false;
  http: HttpClient;
  month: number = 0;
  year: number = 0;
  searchText: string;
  headerTable: any[] = InvoiceTicketsConst.headerTable;
  isProjectEnable: boolean = false;

  ticketNumberClick(ticket) {
    this.pdf(ticket.uid);
  }

  ticketTotalClick(ticket) {
    this.invoicePaided(ticket.uid, true);
  }

  public rectification(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const selectedTicket: TicketModel = this.dataSource.find(x => x.uid === uid);

    if (selectedTicket != null) {

      if (selectedTicket.totalPaided != 0) {
        this.displayInfo("No es posible rectificar un Ticket que tiene cobros");
        return;
      }

    }

    const ticketRectification = this.dialog.open(TicketDialogRectificationComponent, {
      data: { uid: uid, ticket: this.ticket }
    })
    ticketRectification.afterClosed().subscribe(result => {
      this.dummy.redirectTo(this.router.url);
    })
  }
  //project
  project(uid: string) {

    const selectedTicket = this.dataSource.find(t => t.uid === uid);
    if (!selectedTicket) return;

    this.dialog.open(TicketDialogProjectComponent, {
      data: { uid: uid, ticket: selectedTicket },
    });
  }

  public getList() {
    this.ready = false;

    this.ticketService.getList(this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;




        for (const ticket of this.dataSource) {
          const temp = new ShowQRModel;
          temp.uid = ticket.uid;
          this.showQRList.push(temp);
          ticket.qrcode = new QRCodeModel;
          ticket.qrcode.uid = ticket.uid;
          ticket.qrcode.ver = 1;
          ticket.qrcode.type = 'ticket';
          ticket.qrstring = JSON.stringify(ticket.qrcode);
        }

        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      }
    )
      .catch(data => {
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public ChargeTotalValue(uid: string) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const i = this.dataSource.findIndex(object => object.uid === uid);
    this.ticketService.chargeTotalValue(uid).then(response => {
      this.dataSource[i] = response;
      this.pdf(uid);
      this.dummy.redirectTo(this.router.url);
    }).catch(error => {
    });
  }

  public invoicePaided(uid: string, isTicket: boolean): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const invoicePaidedref = this.dialog.open(InvoiceDialogPaidedComponent, {
      // height: '80%',
      // width: '80%',
      data: { uid: uid, isTicket: isTicket, isIncome: true },

    });

    invoicePaidedref.afterClosed().subscribe(result => {
      this.dummy.redirectTo(this.router.url);
    })
  }

  public invoicePaidedSelected(selectedUids: string[]): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    // Eliminamos los que ya estan pagados y los que estan rectificados
    const dataSelected = this.dataSource.filter(row => selectedUids.includes(row.uid) && row.paided == null && row.rectifying == false);
    selectedUids = dataSelected.map(row => row.uid);


    // Obtenemos el monto restante a pagar de los elementos válidos seleccionados
    let amountSelectedUnpaid: number = 0;
    for (let i = 0; i < dataSelected.length; i++) {
      amountSelectedUnpaid += Utils.GetValueWithDecimals((dataSelected[i].total - dataSelected[i].totalPaided));
    }


    if (selectedUids.length > 0) {
      const invoicePaidedMultipleref = this.dialog.open(InvoiceDialogPaidedComponent, {
        //height: '450px',
        data: { selectedUids: selectedUids, isIncome: true, isTicket: true, isMultiple: true, amountSelectedUnpaid: amountSelectedUnpaid },
      });

      invoicePaidedMultipleref.afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      })
    } else {
      this.displayInfo('No tienes ningún ticket válido selecionado');
    }
  }

  public total() {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    TicketDialogTotalComponent.open(this.dialog, { activityUid: this.core.activitySelected });
  }

  public createTicket() {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.router.navigate(['/invoice/ticket/create']);
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public showQRCode(uid: string) {
    for (const invoice of this.showQRList) {
      if (invoice.uid == uid) {
        if (invoice.show == false) {
          invoice.show = true;
        } else {
          invoice.show = false;
        }
      }
    }
  }

  public pdf(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.ticketService.loadData(uid).then(response => {
      this.ticket = response;
      this.ticketService.pdf(uid).then(response => {
        FileSaver.saveAs(response, Utils.GetPdfName("Ticket_" + this.ticket.ticketNumber));
      })
    });
  }

  public pdfregalo(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.ticketService.loadData(uid).then(response =>
      this.ticket = response);

    this.ticketService.pdfRegalo(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName("Ticket_Regalo_" + this.ticket.ticketNumber));
    })
  }



  ngOnInit() {
    this.getList();
    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
          this.isProjectEnable = activity.isProject;
        });
  }

  showMessageVerifactu(uid: string) {
    this.dialog.open(InvoiceDialogVerifactuComponent, {
      data: { uid: uid, type: 'ticket' }
    });
  }

  public pdfMail(uid: string): void {
    EmailDialogComponent.open(this.dialog, {
      email: '',
      send: email => this.ticketService.pdfMailTicket(uid, encodeURIComponent(email)),
    }).subscribe(email => {
      if (email) this.displayInfo(`Factura simplificada enviada a ${email}`);
    });
  }
  public trackByIndex(i: number) { return i; }

}
